/* ==============================
===  lazy-load               ====
================================= */
var bLazy=null;
function theme_init_lazy_load(){
  try {
    bLazy = new Blazy();
  } catch (err) {}
} // Initialize lazy load

function theme_status_lazy_load() {
  try {
    bLazy.revalidate();
  } catch (err) {
    theme_init_lazy_load();
  }
} /* === DESTROY OR ENABLE LAZY LOAD === */